module.exports = __webpack_public_path__ + "static/media/path0104.de14171d.jpg";